import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { AuthServiceService } from './services/auth-service/auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class FallbackRedirectGuard implements CanActivate {
  constructor(
    private authService: AuthServiceService,
    private router: Router
  ) {}

  canActivate(): UrlTree {
    return this.authService.isLoggedIn()
      ? this.router.parseUrl('/dashboard')
      : this.router.parseUrl('/login');
  }
}
